<template>
    <ul class="inline-flex space-x-2">
        <li class="w-8 h-8 bg-primary rounded">
            <a
                :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
                class="flex justify-around w-full h-full pt-1"
                rel="noopener"
                target="_blank"
                title="Facebook">
                <font-awesome-icon
                    :icon="['fab', 'facebook-f']"
                    :inverse="true"
                    aria-hidden="true"
                    class="w-full h-full"
                    fixed-width/>
            </a>
        </li>
        <li class="w-8 h-8 bg-primary rounded">
            <a
                :href="`https://twitter.com/intent/tweet?text=MMCTS%20${url}`"
                class="flex justify-around w-full h-full"
                rel="noopener" target="_blank"
                title="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0,0,256,256" style="fill: rgb(255, 255, 255);"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;"><path d="M0,256v-256h256v256z" id="bgRectangle"></path></g><g fill="#fff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;"><g transform="scale(10.66667,10.66667)"><path d="M4.4043,3c-0.647,0 -1.02625,0.72877 -0.65625,1.25977l5.98828,8.55859l-6.01172,7.02734c-0.389,0.454 -0.06675,1.1543 0.53125,1.1543h0.66406c0.293,0 0.57172,-0.12856 0.76172,-0.35156l5.23828,-6.13672l3.94336,5.63477c0.375,0.534 0.98667,0.85352 1.63867,0.85352h3.33398c0.647,0 1.02625,-0.72781 0.65625,-1.25781l-6.31836,-9.04297l5.72656,-6.70898c0.332,-0.39 0.05497,-0.99023 -0.45703,-0.99023h-0.8457c-0.292,0 -0.56977,0.12761 -0.75977,0.34961l-4.8418,5.66016l-3.60156,-5.1543c-0.374,-0.536 -0.98467,-0.85547 -1.63867,-0.85547z"></path></g></g></svg>
            </a>
        </li>
        <li class="w-8 h-8 bg-primary rounded">
            <a
                :href="`https://www.linkedin.com/shareArticle?mini=true&url=${url}&summary=&source=AddToAny`"
                class="flex justify-around w-full h-full"
                rel="noopener"
                target="_blank"
                title="LinkedIn">
                <font-awesome-icon
                    :icon="['fab', 'linkedin-in']"
                    :inverse="true"
                    aria-hidden="true"
                    class="w-full h-full"
                    fixed-width/>
            </a>
        </li>
        <li class="w-8 h-8 bg-primary rounded">
            <a
                :href="`http://www.citeulike.org/posturl?url=${url}`"
                class="no-fa"
                rel="noopener"
                target="_blank"
                title="Citeulike">
                <svg class="shareIcon" focusable="false" viewBox="0 0 32 32">
                    <path d="M8 24h16v2H8zm0-6h16v2H8zm0-6h16v2H8zm0-6h16v2H8z" fill="#FFF"/>
                </svg>
            </a>
        </li>
        <li class="w-8 h-8 bg-primary rounded">
            <a :href="`https://www.mendeley.com/sign/in?routeTo=${url}&acw=&utt=`" class="no-fa" rel="noopener"
               target="_blank"
               title="Mendeley">
                <svg class="shareIcon" focusable="false" viewBox="0 0 32 32">
                    <path
                        d="M26.596 18.11c-1.466-.087-2.02-.834-1.93-2.164.076-1.113.274-2.22.418-3.327-.023-1.745-.942-3.13-2.488-3.59-1.583-.47-2.97-.14-4.102 1.15-2.322 2.644-2.616 2.632-5.023-.047-1.15-1.28-2.85-1.66-4.39-.98-1.5.667-2.37 2.237-2.15 3.954.08.625.28 1.235.38 1.863.337 2.123-.107 2.7-2.227 3.148-1.066.228-1.913.786-2.05 1.99-.137 1.22.17 2.39 1.404 2.75.77.226 1.854.084 2.55-.32.96-.553 1.064-1.64.733-2.74-.62-2.05-.028-3.04 2.114-3.34a5.973 5.973 0 0 1 2.568.235c1.302.41 1.692 1.373 1.175 2.65-.45 1.1-.443 2.09.39 2.984.84.9 2.417 1.08 3.518.435 1.12-.657 1.497-1.807 1.042-3.164-.608-1.814-.085-2.783 1.807-3.123a5.94 5.94 0 0 1 2.16.025c1.834.367 2.377 1.377 1.84 3.188-.504 1.698.196 3.09 1.72 3.43 1.332.295 2.624-.607 2.89-2.022.308-1.633-.593-2.882-2.344-2.988zm-10.71-.085a2.556 2.556 0 0 1-2.445-2.57c.01-1.46 1.15-2.567 2.61-2.54 1.47.026 2.57 1.177 2.52 2.627a2.568 2.568 0 0 1-2.682 2.483z"
                        fill="#FFF"/>
                </svg>
            </a></li>
        <li class="w-8 h-8 bg-primary rounded">
            <a
                :href="`mailto:someone@example.com?subject=Have%20you%20seen%20this%20MMCTS%20cardio-thoracic%20surgery%20post%3F&amp;body=I%20thought%20you%20would%20be%20interested%20in%20this%20MMCTS%20%E2%80%8Ccardio-thoracic%20surgery%20video%20post%3A%20${title}%20(${url}).%20%20%20%0D%0A%0D%0AThe%20Multimedia%20Manual%20for%20Cardio-Thoracic%20Surgery%20(MMCTS)%20publishes%20step-by-step%20video%20demonstrations%20of%20surgical%20procedures%2C%20with%20concise%20text%20and%20clear%20graphics.%20It%20is%20a%20free%20service%20from%20the%20European%20Association%20for%20Cardio-Thoracic%20Surgery`"
                class="no-fa"
                title="Email">
                <svg class="shareIcon" focusable="false" viewBox="0 0 32 32">
                    <path
                        d="M26 21.25v-9s-9.1 6.35-9.984 6.68C15.144 18.616 6 12.25 6 12.25v9c0 1.25.266 1.5 1.5 1.5h17c1.266 0 1.5-.22 1.5-1.5zm-.015-10.765c0-.91-.265-1.235-1.485-1.235h-17c-1.255 0-1.5.39-1.5 1.3l.015.14s9.035 6.22 10 6.56c1.02-.395 9.985-6.7 9.985-6.7l-.015-.065z"
                        fill="#FFF"/>
                </svg>
            </a>
        </li>
    </ul>
</template>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        url: {
            type: String,
            required: true
        }
    }
};

</script>
